import React, {useEffect, useState} from 'react';
import './App.css';
import Form from 'react-bootstrap/Form';
import NavigationBar from "./NavigationBar";
import {Company} from "./Company";
import axios from "axios";

interface SetupAppProps {
    company: Company;
    companyTypesUri: string;
    setCompanyType: (newType: string) => void;
    setCompanyDescription: (newDesc: string) => void;
}

function SetupApp(props: SetupAppProps) {

    const {company, companyTypesUri, setCompanyType, setCompanyDescription} = props;
    const [businessTypeItems,setBusinessTypeItems] = useState<string[]>([]);
    const [description, setDescription] = useState<string>("");
    const [oldDescription, setOldDescription] = useState<string>(description);
    const [companyTypeState, setCompanyTypeState] = useState<string>("Other");

    useEffect(() => {
        if (!company) {
            return;
        }
        setDescription(company.description);
        setOldDescription(company.description);
        setCompanyTypeState(company.type);
    }, [company]);

    useEffect(() => {
        if (description === oldDescription) {
            return;
        }
        const descriptionTimeout = setTimeout(() => {
            if (oldDescription !== description) {
                console.log("Updating description", description);
                setCompanyDescription(description);
                setOldDescription(description);
            }
        }, 1000);
        return () => clearTimeout(descriptionTimeout);
    // avoid infinite loop NOT adding olDescription to the deps array
    // eslint-disable-next-line
    },[setCompanyDescription, description]);


    useEffect(() => {
        axios.get(companyTypesUri, {withCredentials: true})
            .then(result => setBusinessTypeItems(result.data as string[]))
            .catch( err => {
                if (err.response.status !== 401) {
                    throw err;
                }
            }
        )
    }, [companyTypesUri]);

    const handleTextChange = (evt: any) => {
        setDescription(evt.target.value);
    }

    const businessTypeReactItems = businessTypeItems.map(
        (item) => <option key={item}>{item}</option>);

    console.log("business type", company.type);
    const businessTypeForm = (
        <Form.Select value={companyTypeState}
                     onChange={(e) => {
                         setCompanyTypeState(e?.target.value);
                         setCompanyType(e?.target.value)}}>
            {businessTypeReactItems}
        </Form.Select>);

    return <div>
        <NavigationBar loggedIn={props.company !== undefined}/>

        <header className="py-5">
            <div className="container px-5">
                <div className="row align-items-center">
                    <div className="col-lg-8 col-xxl-6">
                        <h1>Setup</h1>
                    </div>
                </div>
            </div>
        </header>

        <section className="py-5 bg-light" id="scroll-target">
            <div className="container px-5 my-5">
                <div className="row gx-5 align-items-center">
                    <h3>Company {company.name}</h3>
                    <Form>
                        <Form.Group className="mb-3" controlId="formCompanyPurpose">
                            <Form.Label>Describe your company. The more details you add, more details GenPost will use to generate posts</Form.Label>
                            <Form.Control defaultValue={description} as="textarea" rows={3} onChange={handleTextChange} />
                        </Form.Group>
                        <Form.Group className="mb-2" controlId="formCompanyPurpose">
                            <Form.Label>Type of Business</Form.Label>
                            {businessTypeForm}
                        </Form.Group>
                    </Form>
                </div>
            </div>
        </section>
    </div>;


}

export default SetupApp;